import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RemoveModalComponent } from 'src/app/modal/remove-modal/remove-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DownloadQrComponent } from 'src/app/modal/download-qr/download-qr.component';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { PlantService } from 'src/app/services/plant.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Fancybox } from '@fancyapps/ui';
import { Observable, Observer } from 'rxjs';
import Swiper from 'swiper';
import { GeneratePdfComponent } from 'src/app/_Shared/_Components/_Generic/generate-pdf/generate-pdf.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-plant-details',
  templateUrl: './plant-details.component.html',
  styleUrls: ['./plant-details.component.scss'],
})
export class PlantDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
  images = [];
  plantId: string = null;
  plantDetails: any;
  imageObject = [];
  alldetails: any;
  private subscriptions = new Subscription();
  base64Image: any;
  foodvendorEdit: any;
  foodvendorRemove: any;
  foodvendorCreate: any;

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private commonService: CommonService,
    private plantService: PlantService,
    private elRef: ElementRef,
    private rolebasedactionService: RolebasedactionService,
  ) {
    this.images = [
      './assets/images/Pantry.png',
      './assets/images/Pantry.png',
      './assets/images/Pantry.png',
      './assets/images/Pantry.png',
    ];

    localStorage.setItem('expandNavLand', 'true');
    // const routef = this.sideNavService.routingChunks({
    //   name: 'Landscaping and Vegetation',
    //   subNav: '0',
    //   subNavLink: '',
    // });
    // this.appStateSrv.setSideNavState(routef);
  }

  ngOnInit(): void {
    this.foodvendorEdit = this.rolebasedactionService.checkUserRolePermissionExits('Managed Services:Edit');
    this.foodvendorRemove = this.rolebasedactionService.checkUserRolePermissionExits('Managed Services:Remove');
    this.foodvendorCreate = this.rolebasedactionService.checkUserRolePermissionExits('Managed Services:Create');
    this.route.params.subscribe((params) => {
      this.plantId = params['id'];
    });

    this.getPlantDetails();

    for (let i = 0; i <= this.plantDetails?.vegetationPhotos.length - 1; i++) {
      this.imageObject.push({
        image: this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath,
        thumbImage: this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath,
      });
    }

    // fancybox code
    Fancybox.bind('[data-fancybox="gallery"]', {
      // Custom options
    });
  }

  ngOnDestroy() {
    Fancybox.unbind(this.elRef.nativeElement);
    Fancybox.close();

    localStorage.removeItem('expandNavLand');
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.initializeSwiper();
  }

  private initializeSwiper(): void {
    new Swiper('.swiper-container', {
      slidesPerView: 6,
      spaceBetween: 15,
      allowTouchMove: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
        renderBullet: function () {
          return '<span></span>';
        },
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        375: {
          slidesPerView: 2,
        },
        767: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 5,
        },
        1366: {
          slidesPerView: 6,
        },
      },
    });
  }

  openRemoveModal(plantId: string): void {
    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemoveModalComponent, modalOptions);
    // You can pass data to the modal using the `componentInstance` property
    modalRef.componentInstance.id = plantId;
    console.log(plantId);
  }

  openModal(qrLink: string, vegitationName: string, vegetationId: string, species: string, parkName: string): void {
    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(GeneratePdfComponent, modalOptions);
    // You can pass data to the modal using the `componentInstance` property
    modalRef.componentInstance.link = qrLink ? qrLink : '';
    modalRef.componentInstance.vegname = vegitationName;
    modalRef.componentInstance.vegetationId = vegetationId;
    modalRef.componentInstance.species = species;
    modalRef.componentInstance.displayParkName = parkName; // add park name
  }
  // openQrCodeModal(qrLink: string, vegitationName: string): void {
  //   const modalOptions: NgbModalOptions = {
  //     size: 'md',
  //   };

  //   const modalRef = this.modalService.open(DownloadQrComponent, modalOptions);
  //   // You can pass data to the modal using the `componentInstance` property
  //   modalRef.componentInstance.link = qrLink;
  //   modalRef.componentInstance.vegname = vegitationName;

  //   console.log(qrLink);
  //   let imageUrl = qrLink;
  //   this.getBase64ImageFromURL(imageUrl).subscribe((base64data: string) => {
  //     console.log(base64data);
  //     this.base64Image = 'data:image/png;base64,' + base64data;
  //     // save image to disk
  //     var link = document.createElement('a');

  //     document.body.appendChild(link); // for Firefox

  //     link.setAttribute('href', this.base64Image);
  //     link.setAttribute('download', vegitationName + '.png');
  //     link.click();
  //   });

  //   // this.plantService
  //   //   .downloadSingleQrCode(this.plantId)
  //   //   .subscribe((res) => {
  //   //     console.log(res);
  //   //   });
  // }

  goToEditPage(): void {
    this.router.navigate(['/edit-plant-trees/' + this.plantId]);
  }

  goToPrintPage(): void {
    this.router.navigate(['/print-qr-code/' + this.plantId]);
  }

  //api calls
  getPlantDetails() {
    this.plantService.getPlantDetail(this.plantId).subscribe((res) => {
      if (res.isValid === true) {
        this.plantDetails = res.data;
        console.log(this.plantDetails?.vegetationName);
      } else {
        this.plantDetails = [];
      }
    });
  }

  getBase64ImageFromURL(url: string) {
    return Observable?.create((observer: Observer<string>) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx: CanvasRenderingContext2D = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const dataURL: string = canvas.toDataURL('image/png');

    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
  }
}
